// Project dependencies
import * as Sentry from '@sentry/react';
import '~common/Internationalisation/i18n';
import '@oliasoft-open-source/react-ui-library/dist/global.css';
import ClientConfig from '~client/config';
import { version as appVersion } from '../package.json';

const sentryReplayConfig = {
  maskAllInputs: false,
  maskAllText: false,
  blockAllMedia: false,
};

const sentryIgnoreErrors = [
  'ResizeObserver loop limit exceeded',
  'ResizeObserver loop completed with undelivered notifications',
  'Network Error',
  'NetworkError when attempting to fetch resource',
  'Non-Error promise rejection captured',
];

const shouldCreateSpanForRequest = (url: string): boolean => {
  return !url.includes('zdassets.com') && !url.includes('zendesk.com');
};

const sentryConfig: Sentry.BrowserOptions = {
  dsn: 'https://eeab1bd329144394a834f052807a6c02@o324733.ingest.sentry.io/5903901',
  release: `customer-admin-${appVersion}`,
  environment: ClientConfig.config.sentryEnvironment,

  ignoreErrors: sentryIgnoreErrors,

  tracesSampleRate: 0.5,
  tracePropagationTargets: [/^https:\/\/(.*\.)?oliasoft\.com/],

  // Do not record normal user sessions, only sessions where an error occurs.
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1.0,

  integrations: [
    Sentry.browserTracingIntegration({
      shouldCreateSpanForRequest,
    }),
    Sentry.replayIntegration(sentryReplayConfig),
  ],
};

if (ClientConfig.config.enableSentry) {
  Sentry.init(sentryConfig);
}



